// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150508/js/" + chunkId + "." + {"44":"df92ac4c","225":"c7299191","481":"7dc47df3","486":"cb61a488","770":"e541a254"}[chunkId] + ".0.9163582982711468.chunk.js";
};